import { del, get, post, put, upload } from "./api";
import { Campaign, SetupCampaign } from "../models/Campaign";
import { uri } from "../uri";
import { err, ok, Result, Unit } from "../result";
import { ProblemDetails } from "../models/Http";
import { ProductSyncResult } from "../models/Product";

export const getById = async (
  campaignId: string
): Promise<Result<ProblemDetails, Campaign>> => {
  const response = await get(`/v1/campaigns/${campaignId}`);
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content as ProblemDetails);
};

export const list = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<Campaign>>
> => {
  const response = await get("/v1/campaigns");
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<Campaign>);
  }

  return err(content as ProblemDetails);
};

export const setup = async (
  campaign: SetupCampaign
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post("/v1/campaigns", campaign);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};

export const uploadImage = async (
  offerId: string,
  data: Blob,
  name = "file",
  filename?: string
): Promise<Result<ProblemDetails, any>> => {
  const body = new FormData();

  body.append(name, data, filename);

  const init: RequestInit = {
    method: "POST",
    body: body
  };

  const response = await fetch(
    uri(`/v1/campaigns/offers/${offerId}/image`, {}),
    init
  );
  const content = await response.json();

  if (response.ok) {
    const uploadResult = content as any;
    return ok(uploadResult);
  }

  return err(content as ProblemDetails);
};

export const uploadCampaignProducts = async (
  file: Blob,
  campaign: SetupCampaign
): Promise<Result<ProblemDetails, string[]>> => {
  const body = new FormData();

  body.append("file", file);
  body.append("campaign", btoa(JSON.stringify(campaign)));

  const init: RequestInit = {
    method: "POST",
    body: body
  };

  const response = await fetch(
    uri(`/v1/campaigns/campaign-products`, {}),
    init
  );
  const content = await response.json();

  if (response.ok) {
    const uploadResult = content as any;
    return ok(uploadResult);
  }

  return err(content as ProblemDetails);
};

export const editCampaignStatus = async (
  campaignId: string,
  active: boolean
): Promise<Result<ProblemDetails, any>> => {
  const response = await put(`/v1/campaigns/${campaignId}/status/${active}`);
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content as ProblemDetails);
};

export const deleteCampaign = async (
  campaignId: string
): Promise<Result<ProblemDetails, any>> => {
  const response = await del(`/v1/campaigns/${campaignId}/delete`);
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content as ProblemDetails);
};
